import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { version } from '../../package.json';
import { VersionService } from './shared/services/version.service';
import { GetApiVersionResponse } from './shared/models/version.models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  version: string = version;
  apiVersion: string = '';

  constructor(
    private authService: AuthService,
    private screen: ScreenService,
    public appInfo: AppInfoService,
    private versionService: VersionService 
  ) {}

  ngOnInit() {
    this.loadApiVersion(); 
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }

  private loadApiVersion(): void {
    this.versionService.GetApiVersion({}).subscribe({
      next: (response: GetApiVersionResponse) => {
        if (response && response.apiVersion) {
          this.apiVersion = response.apiVersion;
        } else {
          console.error('API response is invalid or missing the version property:', response);
        }
      },
      error: (err: any) => {
        console.error('Failed to fetch API version:', err);
      }
    });
  }
  
}
